import { configStore } from '@vfde-sails/core';
import './style.scss';
import lmsForm from 'Container/LeadManagementSystemForm';

configStore({}) && lmsForm();

// FF history back fix
window.onunload = () => {};
